import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';
import { AccountRecordMapped } from '@tassat/fred-extended-definitions';
import { RouteComponentProps } from 'react-router-dom';

import { FirmAccountDetailsHeader } from './firmAccountDetailsHeader';
import { muiStyles } from './styles';

type RouteParams = {
    accountId: string;
};

export interface FirmAccountDetailsHeaderProps extends RouteComponentProps<RouteParams>, WithStyles<typeof muiStyles> {
    firm: FirmRecord;
    mappedAccount: AccountRecordMapped;
}

export default withStyles(muiStyles)(FirmAccountDetailsHeader);